import { render } from "./DeleteSurveyModal.vue?vue&type=template&id=f2f694fe"
import script from "./DeleteSurveyModal.vue?vue&type=script&lang=js"
export * from "./DeleteSurveyModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__